import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter'; 
import { Announce } from '@ascschool/model/user/announce.model';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { DepartmentOfEducationAndTrainingService } from '@ascschool/services/organization/department-of-educatio-and-training.service';
import { SchoolService } from '@ascschool/services/organization/school.service'; 
import { AnnounceAttachmentService } from '@ascschool/services/user/announce-attachment.service';
import { AnnounceService } from '@ascschool/services/user/announce.service';
import { StaffService } from '@ascschool/services/user/staff.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { map } from 'rxjs/operators';


@Component({
  selector: 'app-popup-thong-bao',
  templateUrl: './popup-thong-bao.component.html',
  styleUrls: ['./popup-thong-bao.component.scss']
})
export class PopupThongBaoComponent implements OnInit {
  @Input() value: any;
  @Input() filesRes: any = [];
  isEditMode = false; 
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup; 
  announce = new Announce();
  currentUser: any;
  files: any[] = [];
  fileList: NzUploadFile[] = [];
  lstAttach = [];
  lstAttachSaved = [];
  listDVQL: ({
    id: number;
    educationAndTrainingName: string;
    checked: boolean;
  })[] = [];
  listSubordinateTypeSelect: number[] = [];

  listCoso: ({
    id: number;
    educationAndTrainingName: string;
    checked: boolean;
  })[] = [];
  listCosoSelect: number[] = [];

  listStaff: ({
    id: number;
    fullName: string;
    userId: number;
    checked: boolean;
  })[] = [];
  listStaffSelect: number[] = [];

  getProvinceACFn: (value: any) => Observable<any>;
  provinceSubscription: any;
  provinceControl = new FormControl(); 
  commonFilter = new CommonFilter();
  fileSubscription: Subscription; 
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    private fileService : AnnounceAttachmentService,
    private provinceService: ProvinceService,
    private schoolService: SchoolService,
    private staffService: StaffService,
    private service: AnnounceService,
    private soGDService: DepartmentOfEducationAndTrainingService, 
    public utilsService: UtilsService,

    private fb: FormBuilder,
  ) {
  }

  ngOnInit() {   
    
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
    this.announce.isCustom = false;
    if(this.currentUser.accountType == 6 || this.currentUser.accountType == 5){ 
      this.announce.announceType = 1;
    }else if(this.currentUser.accountType == 1){
      this.announce.announceType = 2;
    }else if(this.currentUser.accountType == 3){
      this.announce.announceType = 3;
    }
    
    if (this.value && this.value.id > 0) {
      this.GetById(this.value.id);
      this.isEditMode = true;
      this.announce.id = this.value.id;
      // console.log(this.province); 
    }
    this.loadFileAttacment();
    // this.fileSubscription = this.fileService.done.subscribe((lstId: any) => {
    //   console.log(lstId);
      
    //   if (lstId) { 
    //     lstId.map(x => {
    //       this.fileList.push(x.id);
    //     });
        
    //   }
    // });
    this.loadSoGD();
    this.loadSchool();
    this.loadStaff(); 
    
  }
  GetById(id: number) {
    this.service.getAnnounceById(id).subscribe((res: any) => {
      this.announce = res; 
      if(this.announce){
        this.listStaffSelect = this.announce.listStaff;
        this.listCosoSelect = this.announce.listCoso;
        this.listSubordinateTypeSelect = this.announce.listDVQL;  
        
         res.listAttachment.forEach(q=>{
          this.lstAttach.push(q.fileId);
        }); 
        this.fileList = res.listAttachment.map(x => ({
          uid : x.fileId,
          name : x.fileName,
          status : 'done'
        }));
      }
    })
  }
  close() {
    this.destroyModal();
    // this.fileSubscription.unsubscribe();
    // if(this.files.length){
    //   this.fileService.discardUploadFile().subscribe(() => {
    //     this.closeMe();
    //   })
    // } else{
    //    this.closeMe();
    // }
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
 

 
  UpdateClose() {  
    if(this.announce.title && this.announce.content){ 
      this.bindOfData();  
      this.announce.fromEadId = this.currentUser.eadId; 
      if (this.fileList.length) {
        this.announce.listAttachment = this.lstAttach;
      }   
        this.service.addOrUpdateAnnounce(this.announce).subscribe((res) => {
          if (res.statusCode === 0) {
            this.utilsService.notifyResponse(res);
            this.close();
          } else {
            this.utilsService.notifyResponse(res);
          }
        }, error => {
          this.msg.error('lỗi: ' + error.error.Message);
        }
        ); 
    }else{
      this.msg.warning('Vui lòng chọn các trường bắt buộc')
    }
  }
  hanldeRemove = (file: any) => new Observable<boolean>((obs) => { 
    const indexUser = this.fileList.findIndex(x => x.uid == file.uid);
    const fileId = this.lstAttach[indexUser];  
    this.fileService.discardUploadFile(fileId).subscribe(
        () => {
          this.lstAttach.splice(indexUser, 1);
          this.lstAttachSaved.splice(indexUser, 1);
          this.files.splice(indexUser, 1);
          obs.next(true);
        }
      );
    // const findIdOldFile = this.filesRes.findIndex(x => x.uid == fileId); 
    // console.log(findIdOldFile);
    // if (findIdOldFile > -1) { 
    //   this.fileService.discardUploadFile(fileId).subscribe(
    //     () => {
    //       this.lstAttach.splice(indexUser, 1);
    //       this.lstAttachSaved.splice(indexUser, 1);
    //       this.files.splice(indexUser, 1);
    //       obs.next(true);
    //     }
    //   );
    // }else{ 
    //   this.lstAttach.splice(indexUser, 1);
    //   this.lstAttachSaved.splice(indexUser, 1);
    //   this.files.splice(indexUser, 1);
    //   obs.next(true);
    // }
  });
  bindOfData() {
    this.announce.listStaff = this.listStaffSelect; 
    this.announce.listCoso = this.listCosoSelect; 
    this.announce.listDVQL = this.listSubordinateTypeSelect;
    
  }
  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value != 'string') { return control.value.id; }
    return '';
  }
  loadProvince() {
    this.getProvinceACFn = (value: any) => this.provinceService.GetSelectPagingProvinceBySubordinateType({ ProvinceName: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.length > 0 ? resp.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.provinceSubscription) {
      this.provinceSubscription = this.provinceControl.valueChanges.subscribe(() => {
        this.utilsService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.provinceControl.value);
      });
    }
  }

  changeProvince(control: FormControl) {
    if (control.value) {
      this.provinceControl = control;
      // this.loadSoGD(); 
      // this.SoGDControl.setValue(null);
       
      if (this.currentUser.accountType === 5 || this.currentUser.accountType === 6) {
        this.loadSchool();
      }
      if (this.currentUser.accountType === 1) {
        this.commonFilter.subordinateTypeId = this.currentUser.eadId;
        this.loadSchool();

      }
    }
  }

  loadSoGD() {
    this.soGDService.getSelectPaging({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      this.listDVQL = res.results.map(x => ({ id: x.id, educationAndTrainingName: x.educationAndTrainingName, checked: false }));
    });
  }


  loadSchool() {
    this.schoolService.GetSelectPagingCoSoTheoUserId({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      this.listCoso = res.results.map(x => ({ id: x.id, educationAndTrainingName: x.educationAndTrainingName, checked: false }));
    });
  }
 

  loadStaff() {
    this.staffService.GetSelectPagingNhanSuThuocCoSo({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      this.listStaff = res.results.map(x => ({ id: x.userId, fullName: x.fullName,userId: x.userId, checked: false, }));
    });
  }
 
  beforeUpload = (file: NzUploadFile): boolean => {
    let files: NzUploadFile[] = [];
    files.push(file);
    this.fileList = this.fileList.concat(file);  
     this.prepareFilesList(files);
    return false;
  };
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 100;
      this.files.push(item);
      this.fileService.addFileToQueue(item);
    }
  }
  loadFileAttacment(){
    this.fileService.done.subscribe((lstId: any) => {
      if (lstId) {  
        lstId.map(x => {
          this.lstAttach.push(x.fileId);
          this.lstAttachSaved.push(x);
        });
      }
    });
  }
    closeMe() {
      this.fileService.clear(); 
    }
}
